import * as types from "../types";
import { setInitialState } from "../../../../store/InitialState";

const INITIAL_STATE = setInitialState({
    data: null,
    isFetching: false,
    isSuccess: false,
    isError: false,
    error: false
});

export default function (state = INITIAL_STATE, action: any) {
    switch (action.type) {
        case types.ADD_NEW_CASE_REQUEST:
            return {
                ...state,
                isFetching: true,
                isSuccess: false,
                isError: false,
            };
        case types.ADD_NEW_CASE_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                data: action.payload
            };
        case types.ADD_NEW_CASE_FAILURE:
            if (action.error && action.payload.name === "RequestError") {
                return {
                    ...state,
                    isError: true,
                    isFetching: false,
                    data: { message: "INTERNET_OFFLINE_MESSAGE" }
                };
            } else {
                return {
                    ...state,
                    isFetching: false,
                    isError: true,
                    isSuccess: false,
                    data: action.payload,
                };
            };
        case types.RESET_ADD_NEW_CASE:
            return {
                ...state,
                isFetching: false,
                isSuccess: false,
                isError: false,
                data: null,
            };
        default:
            return {
                ...state
            }
    }
}